exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.popup[data-v-b9bd324a] {\n  z-index: 100;\n  background: white;\n  border-radius: 4px;\n  border: 1px solid rgba(0,0,0,0.2);\n  -webkit-box-shadow: 2px 2px rgba(0,0,0,0.1);\n          box-shadow: 2px 2px rgba(0,0,0,0.1);\n}\nbutton.close-btn[data-v-b9bd324a] {\n  position: absolute;\n  top: 12px;\n  right: 5px;\n  border: none;\n  background: none;\n  font-size: 32px;\n  line-height: 0%;\n}\n", ""]);

// exports
